/**
 * アプリケーション内で使用されるエラーコードを定義
 * @note src/utils/globalError/globalError.tsで errorCodeとerrorMessageをthrowする
 * @see {@link ./errorMessage.ts} エラーメッセージ定義
 * @readonly
 */

/** エラーコード */
export const ERROR_CODES = {
  /** 共通メッセージ */
  ROUTE_ACCESS_ERROR: '411000',
  API_EXECUTION_FAILED: '411010',

  /** ログイン画面 */
  USER_INFO_FETCH_FAILED: '411100',
  NO_ACCESSIBLE_SCREENS: '411110',
  GOVERNMENT_SETTING_FAILED: '411120',

  /** アノテーション選択画面 */
  USER_INFO_FETCH_FAILED_ANNOTATION: '411200',
  ANNOTATION_INFO_FETCH_FAILED: '411210',

  /** 被害状況可視化画面 */
  USER_INFO_FETCH_FAILED_VISUALIZATION: '411300',
  DISASTER_INFO_FETCH_FAILED: '411310',
  GOVERNMENT_SETTING_FETCH_FAILED: '411311',
  MAP_INFO_FETCH_FAILED: '411312',
  BUILDING_INFO_FETCH_FAILED: '411313',
  INSPECTION_INFO_FETCH_FAILED: '411314',
  CSV_CREATION_FAILED: '411315',
  IMAGE_DOWNLOAD_FAILED: '411316',
  EMERGENCY_INSPECTION_INFO_FETCH_FAILED: '411317',
  AI_BUILDING_INFO_FETCH_FAILED: '411318',
  FETCH_DONUT_DATA_FAILED: '411319',
  GEO_SERVER_RUN_FAILED: '411320',
  GEO_SERVER_VERIFY_FAILED: '411321',
  GET_BUILDING_DETAILS_FAILED: '411322',
  REGISTER_ICON_IMAGE_FAILED: '411323',
  GET_AERIAL_AREAS_FETCH_FAILED: '411324',
  ANNOTATION_IMAGE_FETCH_FAILED: '411325',
  CLASSIFICATION_ANNOTATION_RUN_FAILED: '411326',
  DISASTER_INFO_NOT_SET: '411327'
} as const
